export const isEmptyStr = (value: null | undefined | string) => {
  return value === undefined || value === null || value.trim() === "";
};
